export const GetAverage = (values: number[]): number => {
  if (values.length === 0) return 0;

  const sum = values.reduce((a, c) => a + c, 0);
  return sum / values.length;
};
